import React, { Component, Fragment, createRef } from 'react';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import classNames from 'classnames';
import { parseRenderOptions } from './utils';

export class FieldWrapper extends Component {
  constructor(props) {
    super(props);
    this.helpRef = createRef();
  }

  render() {
    if (!this.props.visible) return null;

    // Determine html tags to use for the field wrapper
    const [GroupTag, LabelTag] = !this.props.fieldset
      ? ['div', 'label']
      : ['fieldset', 'legend'];

    const {
      isRequired,
      isFloating,
      hasLabel,
      hasLabelHelpText,
      hasInlineHelpText,
      disabledMessage,
      hasEmptyOptions,
      EmptyOptionsPlaceholder,
      hasErrors,
      omitWrapper,
      wrapperClassName,
    } = this.props.renderOptions || parseRenderOptions(this.props) || {};

    // Build content as the disable message, empty options placeholder, or
    // field element
    const content = disabledMessage ? (
      <div className="no-data">{disabledMessage}</div>
    ) : hasEmptyOptions ? (
      <EmptyOptionsPlaceholder />
    ) : (
      this.props.children
    );

    // If wrapper should be omitted, render only the content
    if (omitWrapper || this.props.omitFieldWrapper) return content;

    // Determine html tags to use for the label wrapper
    const [LabelWrapper, labelWrapperProps] = this.props.action
      ? ['div', { className: 'label-group' }]
      : [Fragment, {}];

    const label = hasLabel ? (
      <LabelWrapper {...labelWrapperProps}>
        <LabelTag
          className={classNames({
            'form-helper-popover': hasLabelHelpText,
            required: isRequired,
          })}
          htmlFor={this.props.id}
          ref={this.helpRef}
        >
          {this.props.label}
        </LabelTag>
        {/* Add label popover for help text if appropriate */}
        {hasLabelHelpText && (
          <UncontrolledPopover
            placement="top"
            trigger="legacy"
            target={this.helpRef}
          >
            <PopoverBody>{this.props.helpText}</PopoverBody>
          </UncontrolledPopover>
        )}
        {this.props.action}
      </LabelWrapper>
    ) : null;

    return (
      <GroupTag
        className={classNames(
          'form-group',
          this.props.className, // TODO remove?
          wrapperClassName,
          {
            'form-floating': isFloating,
          },
        )}
        aria-required={this.props.fieldset && isRequired}
      >
        {/* If not floating, show label above field element */}
        {!isFloating && label}
        {/* Render the content */}
        {content}
        {/* If is floating, show label below field element */}
        {isFloating && label}
        {/* Show inline help text if appropriate */}
        {hasInlineHelpText && (
          <span className="form-text">{this.props.helpText}</span>
        )}
        {/* Show errors if there are any */}
        {hasErrors &&
          this.props.errors.map(error => (
            <span className="form-text text-danger" key={error}>
              {error}
            </span>
          ))}
      </GroupTag>
    );
  }
}
